import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import Passenger from '@websky/core/src/PassengerForm/components/PassengerForm';
import { AdditionalTravellerFieldEnum } from '@websky/core/src/Passenger/types';
import { getInputType } from '@websky/core/src/Checkout/components/Checkout/Form/Passengers/Passengers';
const CheckoutFormPassenger = props => {
    const { t } = useTranslation('Passenger');
    const fields = useMemo(() => {
        if (props.needOthsSsr) {
            return [
                ...props.fields,
                {
                    name: 'organizationName',
                    readonly: false,
                    type: AdditionalTravellerFieldEnum.OrganizationName,
                    input: getInputType(AdditionalTravellerFieldEnum.OrganizationName),
                    placeholder: t('organizationName'),
                    validations: [
                        {
                            required: true,
                            with: null,
                            hidden: null,
                            label: null,
                            hint: null,
                            placeholder: null,
                            minDate: null,
                            maxDate: null,
                            maxLength: null,
                            regExp: null,
                            options: null
                        }
                    ],
                    defaultValue: ''
                },
                {
                    name: 'personnelNumber',
                    readonly: false,
                    type: AdditionalTravellerFieldEnum.PersonnelNumber,
                    input: getInputType(AdditionalTravellerFieldEnum.PersonnelNumber),
                    placeholder: t('personnelNumber'),
                    validations: [
                        {
                            required: true,
                            with: null,
                            hidden: null,
                            label: null,
                            hint: null,
                            placeholder: null,
                            minDate: null,
                            maxDate: null,
                            maxLength: null,
                            regExp: null,
                            options: null
                        }
                    ],
                    defaultValue: ''
                }
            ];
        }
        return props.fields;
    }, [props.needOthsSsr, props.fields]);
    return React.createElement(Passenger, Object.assign({}, props, { fields: fields }));
};
export default CheckoutFormPassenger;
